import { listOfSubscriptions } from "../../../common/envConfig";

export const dateExtractFromSub = (sub) => {
  if (sub.status === "active" && sub.endDate < Date.now()) {
    return {
      startDate: sub?.oldSubscription?.startDate,
      endDate: sub?.oldSubscription?.endDate,
    };
  } else {
    return { startDate: sub.startDate, endDate: sub.endDate };
  }
};

export const discountedPrice = ({
  previousSubStartDate,
  previousSubEndDate,
  planPriceCents,
}) => {
  const startDate = Number(previousSubStartDate);
  const endDate = Number(previousSubEndDate);
  const now = Date.now();

  // basic sanity checks
  if (isNaN(startDate) || isNaN(endDate) || endDate <= startDate) return 0;

  // if expired or past end date, no remaining credit
  if (now >= endDate) return 0;

  const totalDuration = endDate - startDate; // total plan period in ms
  const remainingDuration = endDate - now; // unused time left in ms

  const remainingFraction = remainingDuration / totalDuration;

  // Remaining credit (portion of the plan unused)
  const remainingCredit = Math.round(planPriceCents * remainingFraction);

  return remainingCredit; // in cents
};

export const planProrationEligibility = (oldPlan, newPlan) => {
  const upgradeFromPlans = [
    listOfSubscriptions.STUDENT_LITE_MONTHLY,
    listOfSubscriptions.STUDENT_LITE_ANNUALLY,
  ];
  const upgradeToPlans = [
    listOfSubscriptions.PLAYER_PLUS_MONTHLY,
    listOfSubscriptions.PLAYER_PLUS_ANNUALLY,
  ];

  if (!upgradeFromPlans.includes(oldPlan) || !upgradeToPlans.includes(newPlan))
    return false;

  if (oldPlan.includes("annually") && !newPlan.includes("annually")) {
    return false;
  }

  return true;
};
